import React from 'react';
import { Button } from '@ui/Button';
import { Card } from '@ui/Card';

export const GuestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-blue-600 to-purple-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            欢迎来到少儿AI编程学习平台
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-blue-100">
            通过有趣的AI项目，让孩子们轻松学习编程和人工智能
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="secondary"
              size="lg"
              //onClick={() => window.location.href = '/scratch'}
              onClick={() => window.open('/scratch/', '_blank')}
              className="bg-white text-blue-600 hover:bg-gray-100"
            >
              Scratch编程 
            </Button>
            {/* <Button
              variant="outline"
              size="lg"
              //onClick={() => window.location.href = '/main'}
              className="border-white text-white hover:bg-white hover:text-blue-600"
            >
              了解更多
            </Button> */}
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              为什么选择我们？
            </h2>
            <p className="text-xl text-gray-600">
              为孩子们设计的AI学习平台，寓教于乐
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <Card className="p-8 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                趣味学习
              </h3>
              <p className="text-gray-600">
                通过游戏化的方式学习AI概念，让学习变得更有趣
              </p>
            </Card>

            <Card className="p-8 text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                实战项目
              </h3>
              <p className="text-gray-600">
                真实的AI项目开发，亲手训练自己的AI模型
              </p>
            </Card>

            <Card className="p-8 text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                快速进步
              </h3>
              <p className="text-gray-600">
                个性化的学习路径，让孩子按照自己的节奏成长
              </p>
            </Card>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-blue-600 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            准备开始你的AI学习之旅了吗？
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            立即注册，解锁AI学习功能
          </p>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => window.location.href = '/register'}
            className="bg-white text-blue-600 hover:bg-gray-100 mx-auto"
          >
            免费注册
          </Button>
        </div>
      </div>

      {/* Stats Section */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <p className="text-4xl font-bold text-blue-600 mb-2">1000+</p>
              <p className="text-gray-600">活跃学生</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-green-600 mb-2">50+</p>
              <p className="text-gray-600">AI项目</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-purple-600 mb-2">95%</p>
              <p className="text-gray-600">满意度</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-orange-600 mb-2">24/7</p>
              <p className="text-gray-600">在线支持</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};